// extracted by mini-css-extract-plugin
export var page_navigation = "PageNav-module--page_navigation--4E769";
export var nav_button = "PageNav-module--nav_button--MvYst";